import React from 'react';

const SVG = ({
  style = {},
  fill = '#9192a4',
  width = '100%',
  className = '',
  viewBox = '0 0 30 30',
  title = 'API Keys',
}: any) => (
  <svg
    fill={fill}
    width={width}
    style={style}
    className={`svg ${className}`}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {`
          .svg-fill-apikeys { fill: ${fill}; }
          .svg-apikeys-2 { fill: none; }
        `}
      </style>
    </defs>
    <title>{title}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Isolation_Mode" data-name="Isolation Mode">
        <path
          className="svg-fill-apikeys"
          d="M24.34,9.64A2.48,2.48,0,0,0,22.19,8L22,8h0a2.5,2.5,0,0,0-2.5,2.5,2.63,2.63,0,0,0,.14.8L16.72,13a3,3,0,0,0-1.58-.93l.33-4.15a1.5,1.5,0,1,0-1,0L14.14,12a3,3,0,0,0-1.55.67L10.41,11a1.28,1.28,0,0,0,.09-.48,1.4,1.4,0,0,0-.12-.58A1.49,1.49,0,0,0,9.13,9H9a1.5,1.5,0,0,0,0,3h.13a1.61,1.61,0,0,0,.66-.22l2.14,1.7A2.93,2.93,0,0,0,11.5,15,3,3,0,0,0,12,16.7L9.41,19.44A2.46,2.46,0,0,0,8,19a2.52,2.52,0,1,0,2.1,1.16l2.64-2.75A2.91,2.91,0,0,0,14.5,18a3,3,0,0,0,1.24-.27l4,5a1.52,1.52,0,0,0-.23.79A1.5,1.5,0,1,0,21,22a1.37,1.37,0,0,0-.49.09l-3.94-4.93A3,3,0,0,0,17.5,15a3,3,0,0,0-.24-1.16l2.88-1.68A2.5,2.5,0,0,0,22,13h0l.19,0a2.49,2.49,0,0,0,2.14-1.59,2.43,2.43,0,0,0,.17-.89A2.48,2.48,0,0,0,24.34,9.64ZM8,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,8,23Zm13,0a.5.5,0,1,1-.5.5A.5.5,0,0,1,21,23ZM15,6a.5.5,0,1,1-.5.5A.5.5,0,0,1,15,6Zm-.5,11a2,2,0,1,1,2-2A2,2,0,0,1,14.5,17Z"
        />
        <rect className="svg-apikeys-2" width="30" height="30" />
      </g>
    </g>
  </svg>
);

export default SVG;
